// Errors/Sentry module that handles setting up and communicating with the Sentry service
// for monitoring javascript errors that users/clients experience in production
GP.GPMod('Errors',function(self) {
    var vent       = null;
    var common     = null;
    var _log       = null;
    var _check_obj = function() {};
    var log_level  = 2;

    var error_timer_name = 'handle_pending_errors';
    var pending_errors   = [];

    var _data = {
        // check and initialize a few params
        init: function() {
            vent       = self.vent;
            common     = self.app.Util;
            _log       = self.app.Util.log;
            _check_obj = self.app.Util.check_obj;

            _data.sentry_dsn      = _sentry_conf.raven_dsn;
            _data.release_version = _sentry_conf.release;
        },

        sentry_dsn:      null,
        release_version: null,
    };


    var util = {
        // return custom error object
        get_error: function(error_obj, name, message) {
            var default_name = 'Custom Error: ' + (name || "");

            if (typeof error_obj != 'undefined' && error_obj instanceof Error) {
                error_obj.name = default_name;

                if (typeof message != 'undefined' && message) {
                    error_obj.message = message + ' ' + error_obj.message;
                }
                return error_obj;
            } else {
                var error = new Error((message || "No message supplied"));
                error.name = default_name;
                return error;
            }
        }
    };


    // these methods are for dealing with the sentry error monitoring service
    var sentry = {
        setup: function() {
            if (typeof Sentry != 'undefined') {
                Sentry.setUserContext({
                    duid:       GP.sdata.my_user.duid,
                    username:   GP.sdata.my_user.username,
                    membership: GP.sdata.my_user.membership,
                    gender:     GP.sdata.my_user.gender,
                });
            }
        },
        send_error: function(error_obj, error_data) {
            if (typeof Sentry != 'undefined') {
                Sentry.captureException(error_obj, {
                    tags: {
                        send_location: 'GP.Errors.sentry.send_error'
                    },
                    extra: (error_data || {})
                });
            }
        },
        send_message: function(message, error_data) {
            if (typeof Sentry != 'undefined') {
                Sentry.captureMessage(message, {
                    tags: {
                        send_location: 'GP.Errors.sentry.send_message'
                    },
                    extra: (error_data || {})
                });
            }
        },
        // basically wraps function argument in a try catch for sending to sentry
        // function will run immediately and an exception will be caught/sent
        context: function(func) {
            if (typeof Sentry != 'undefined') {
                Sentry.context(func);
            }
        },
        // nearly identical to "context" but returns the wrapped function
        // so it can be passed around as a callback
        wrap: function(func) {
            if (typeof Sentry != 'undefined') {
                return Sentry.wrap(func);
            }
        }
    };

/*
    // these methods are for dealing with errorception
    var errorception = {
        add_error_meta: function(obj) {
            if (typeof _errs != 'undefined' && typeof obj != 'undefined' && obj) {
                $.extend(_errs.meta, obj);
            }
        },
        reset_error_meta: function() {
            if (typeof _errs != 'undefined') {
                _errs.meta = {
                    user:    GP.sdata.my_user.duid + '/' + GP.sdata.my_user.gender + '/' + GP.sdata.my_user.membership,
                    js_hash: _js_initial_hash
                };
            }
        },
        handle_pending_errors: function() {
            if (pending_errors.length > 0) {
                // grab the first error off the stack (FIFO)
                var obj = pending_errors.shift();

                // modify the global errorception meta object
                self.errors.add_error_meta(obj.meta_data);

                // call push_error with no meta data so it sends immediately with the meta data we modified above
                self.errors.push_error(obj.error_obj);

                // call ourselves again after a small delay so we continue processing errors, or reset and clear
                self.timers.set(self.errors.handle_pending_errors, 750, error_timer_name);
            } else {
                self.errors.reset_error_meta();
                self.timers.clear(error_timer_name);
            }
        },
        push_error: function(error, meta) {
            // push error to errorception if we have that object and a valid Error
            if (typeof _errs != 'undefined' && _errs.push) {
                if (typeof error != 'undefined' && error instanceof Error) {

                    // if we have meta data, we will put in a queue of pending errors so we can match up their meta data/error
                    if (typeof meta != 'undefined' && meta) {
                        pending_errors.push({
                            error_obj: error,
                            meta_data: meta
                        });

                        // if we don't have a timer, then we aren't waiting, so start processing the errors
                        if (!self.timers.exists(error_timer_name)) {
                            self.errors.handle_pending_errors();
                        }
                    } else {
                        _errs.push(error);
                    }
                }
            }
        }
    };


    this.addInitializer(function() {
        // don't setup cometd if we are only showing a profile by itself (no header, nav etc...)
        if (typeof _profile_only != 'undefined' && _profile_only) {
            return;
        }

        // initialize this modules _data object
        _data.init();

        // setup the raven client that sends errors to sentry (add user context etc...)
        // sentry.setup(); // setting sentry up in lib/util/tracking.php:tracking_sentry() function instead of here

        self.sentry = sentry;
        self.util   = util;

        // expose some functions
        self.get_error = util.get_error;
    });
*/

});
